import * as React from "react";

interface JSIconProps {
	fillColor: string;
	iconColor: string;
	style: any;
}

const JSIcon = (props: JSIconProps) => (
	<svg
		width="16px"
		height="16px"
		viewBox="0 0 16 16"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<defs />
		<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g id="Main" transform="translate(-182.000000, -100.000000)" fill="#FFFFFF">
				<g id="Group" transform="translate(22.000000, 98.000000)">
					<g id="Page-1" transform="translate(160.000000, 2.000000)">
						<path
							d="M12.2625125,14.7454812 C10.866325,14.7454812 9.9641375,14.0796687 9.523825,13.2096687 L10.7481375,12.5007937 C11.0703875,13.0271062 11.4892625,13.4137312 12.2302625,13.4137312 C12.8532625,13.4137312 13.250575,13.1022312 13.250575,12.6726062 C13.250575,12.1571063 12.84245,11.9744813 12.155075,11.6738563 L11.779325,11.5126063 C10.69445,11.0509188 9.974825,10.4709187 9.974825,9.24660625 C9.974825,8.11885625 10.834075,7.25960625 12.1766375,7.25960625 C13.1325125,7.25960625 13.8198875,7.59254375 14.313825,8.46254375 L13.1432,9.21429375 C12.8853875,8.75248125 12.6062,8.56991875 12.1766375,8.56991875 C11.7362625,8.56991875 11.4570125,8.84916875 11.4570125,9.21429375 C11.4570125,9.66541875 11.7362625,9.84804375 12.3806375,10.1272937 L12.75645,10.2884187 C14.0346375,10.8361687 14.7542,11.3946062 14.7542,12.6511062 C14.7542,14.0045437 13.6908875,14.7454812 12.2625125,14.7454812 Z M8.707075,12.4791687 C8.707075,14.0364812 7.7942625,14.7453563 6.4623875,14.7453563 C5.2596375,14.7453563 4.56145,14.1224812 4.2070125,13.3707312 L4.20695,13.3707938 L4.20695,13.3706688 L4.2070125,13.3707312 L5.43145,12.6297312 C5.6676375,13.0486062 5.8825125,13.4029812 6.39795,13.4029812 C6.8920125,13.4029812 7.2035125,13.2096687 7.2035125,12.4579188 L7.2035125,7.34554375 L8.707075,7.34554375 L8.707075,12.4791687 Z M1.25e-05,15.9999813 L16.0000125,15.9999813 L16.0000125,-1.875e-05 L1.25e-05,-1.875e-05 L1.25e-05,15.9999813 Z"
							id="Fill-1"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export default JSIcon;



// WEBPACK FOOTER //
// ./src/components/PlatformSelector/JSIcon.tsx